import React, { useMemo } from 'react';
import classes from '../AssignRealPlay/RealPlay.module.scss';
import Loading from 'shared_ui_components/Loading';
import { Avatar } from '@material-ui/core';
import { VolumeUp } from '@material-ui/icons';
import { InputSelect, InputText, TextArea } from 'shared_ui_components';
import { components } from 'react-select';
import { buyingContext } from '../AssignRealPlay/AssignRealPlayContants';
import AssignRealPlayDataHelper from 'features/realplays/AssignRealPlayData.helper';

const RoleplayAIProspect = ({ isLoadingAttitudes, isLoadingCoach }) => {
  const {
    personas_ai,
    attitudes,
    context,
    updateAttitudesSelection,
    updatePersonaSelection,
    updateIndustrySelector,
    updateTitleContext,
    updateCustomerSituation,
  } = AssignRealPlayDataHelper();

  const handleSelectPersona = (uuid) => updatePersonaSelection(uuid);
  const handleSelect = (id) => updateAttitudesSelection(id);

  const industries = useMemo(() => {
    return buyingContext?.map((item) => ({
      label: item?.industry,
      value: item?.industry,
      description: item?.description,
    }));
  }, []);

  const handleChangeTitle = (value) => updateTitleContext(value);
  const handleChangeTextArea = (text) => updateCustomerSituation(text);
  const handleChangeIndustry = (option) =>
    updateIndustrySelector(option?.value, option?.description);

  return (
    <div className={classes.detailsContainer}>
      <div style={{ border: '1px solid #ECEFF1', borderRadius: '12px', padding: '12px' }}>
        <p className="heading5" style={{ marginBottom: '0.7rem', color: '#193448' }}>
          Step 1: Select your AI prospect
        </p>
        <div style={{ display: 'flex', gap: '0.2rem' }}>
          <p className={classes.deadlineTitle}>Your AI prospect </p>
          <p style={{ color: 'red' }}>*</p>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2,1fr)',
            gap: '0.5rem',
          }}
        >
          {isLoadingCoach ? (
            <Loading loading circular margin={100} width="100%" />
          ) : (
            (personas_ai ?? []).map((i, index) => {
              return (
                <div
                  className={classes.coach}
                  key={`persona-${index}`}
                  style={
                    i?.isSelected ? { backgroundColor: '#E9F6FF' } : { border: '1px solid #E7F0F5' }
                  }
                  onClick={() => handleSelectPersona(i?.uuid)}
                >
                  <Avatar
                    alt="img_persona"
                    src={i?.profile_pic}
                    style={{ width: '48px', height: '48px' }}
                  />
                  <div className={classes.details}>
                    <div>
                      <VolumeUp fontSize="small" />
                      <p>{i?.name}</p>
                    </div>
                    <p style={{ color: '#607d8b' }}>{i?.description ?? 'By SalesTable'}</p>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div style={{ marginTop: '0.3rem' }}>
          <div style={{ display: 'flex', gap: '0.2rem' }}>
            <p className={classes.deadlineTitle}>Attitude</p>
            <p style={{ color: 'red' }}>*</p>
          </div>
          <div className={classes.attitude}>
            {isLoadingAttitudes ? (
              <Loading loading circular margin={100} width="100%" />
            ) : (
              (attitudes ?? []).map((i, index) => {
                return (
                  <div
                    key={`att-${index}`}
                    style={
                      i?.isSelected
                        ? {
                            backgroundColor: '#E9F6FF',
                            color: '#1F99FE',
                            fontWeight: 600,
                          }
                        : {
                            border: '1px solid #E7F0F5',
                            fontWeight: 400,
                            color: '#193448',
                          }
                    }
                    onClick={() => handleSelect(i?.uuid)}
                  >
                    {i?.name}
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>

      <div style={{ border: '1px solid #ECEFF1', borderRadius: '12px', padding: '12px' }}>
        <p className="heading5" style={{ marginBottom: '0.7rem', color: '#193448' }}>
          Step 2: Set the buying context
        </p>

        <InputSelect
          label={
            <div style={{ display: 'flex', gap: '0.2rem' }}>
              <p>Industry</p>
              <p style={{ color: 'red' }}>*</p>
            </div>
          }
          placeholder="Select industry"
          onChange={(value) => handleChangeIndustry(value)}
          options={industries}
          value={industries.find((opt) => opt?.value === context?.industry)}
          closeMenuOnSelect={true}
          noOptionsMessage={() => 'No matches found'}
          components={{ Option: CustomOption }}
        />

        <div>
          <div style={{ display: 'flex', gap: '0.2rem' }}>
            <p className={classes.deadlineTitle}>Role or Title</p>
            <p style={{ color: 'red' }}>*</p>
          </div>
          <InputText
            id="goalTarget"
            placeholder="e.g. VP of Sales"
            value={context?.title}
            onChange={(e) => handleChangeTitle(e.target.value)}
          />
        </div>
        <div>
          <div style={{ display: 'flex', gap: '0.2rem' }}>
            <p className={classes.deadlineTitle}>Customer Situation</p>
            <p style={{ color: 'red' }}>*</p>
          </div>
          <TextArea
            rows={4}
            placeholder="Enter new roleplay's description"
            value={context?.customer_situation}
            onChange={(e) => handleChangeTextArea(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

const CustomOption = ({ innerRef, innerProps, ...rest }) => {
  return (
    <div ref={innerRef} {...innerProps}>
      <components.Option {...rest}>
        <div className={classes.customRoleplayOpt}>
          <p>{rest?.data?.label}</p>
        </div>
      </components.Option>
    </div>
  );
};

export default RoleplayAIProspect;
